import Vue from 'vue'

const fournisseurs = {
  namespaced: true,
  state: {
    produitsUtilisateur: []
  },
  getters: {
    produitsFamille: (state) => (familleId) => {
      return state.familles.find(item => item.id === familleId)
    },
    getProduit: state => id => {
      return state.produitsUtilisateur.find(p => p.id === id)
    },
    getProduits: state => {
      return state.produitsUtilisateur
    }
  },
  actions: {
    clear({ commit }) {
      commit('clearState')
    },
  },
  mutations: {
    clearState(state) {
      state.produitsUtilisateur = []
      state.familles = []
    },
    setItems(state, items) {
      Vue.set(state, items.key, items["data"])
    }
  }
}

export default fournisseurs
